import DataServiceTable from "./DataServiceTable";

export default function MyDataService() {
  return <DataServiceTable variant="page" />;
}
